// extracted by mini-css-extract-plugin
export default {"table":"BidTable_table__i28lO"};